import styled from 'styled-components'

const StyledGalleryView = styled.div`
  
`

export default StyledGalleryView
